
import { Vue } from "vue-class-component";
import { formatDateNormal } from '@/app/infrastructures/misc/Utils';
import { PusatResolusiV2Controller } from "@/app/ui/controllers/PusatResolusiV2Controller";
import { DownloadLaporanRequest } from "@/data/payload/api/PusatResolusiV2ApiRequest";
import { ApiRequestList } from "@/domain/entities/MainApp";

export default class extends Vue {
  form = new DownloadLaporanRequest();
  setDateRange([startDate, endDate]: string[]) {
    this.form = new DownloadLaporanRequest({
      startDate,
      endDate
    });
  }

  onReset() {
    this.form = new DownloadLaporanRequest();

    const ref: any = this.$refs?.["pusat-resolusi-report-time-range-picker"];
    ref?.onSelectOption?.(ref?.options[1]);
    ref?.reset?.();
  }

  async onDownload() {
    try {
      const ref: any = this.$refs?.["pusat-resolusi-report-time-range-picker"];
      ref?.onClick?.();

      if (this.form.startDate && this.form.endDate) {
        await PusatResolusiV2Controller.requestDownloadLaporan(
          new DownloadLaporanRequest({
            startDate: formatDateNormal(this.form.startDate, "YYYY-MM-DD"),
            endDate: formatDateNormal(this.form.endDate, "YYYY-MM-DD"),
          })
        );
        PusatResolusiV2Controller.getBulkDownload(new ApiRequestList());
        PusatResolusiV2Controller.openWidgetDownload();
      }
    } catch (error) {
      console.log("🚀 ~ extends ~ onDownload ~ error:", error);
    }
  }
}
